import classnames from 'classnames';
import React, {Component} from 'react';
import {inject, observer} from 'mobx-react'; // eslint-disable-line no-unused-vars

import TextEditor from './textField/TextEditor';
import TextViewer from './textField/TextViewer';

import './TextField.scss';

@inject('personaStore', 'templateStore')
@observer
export default class TextField extends Component {
  state = {
    editing: false
  }

  editMode = () => {
    if (!this.props.personaStore.isEditable)
      return;
    this.setState({editing: true});
  }

  viewMode =() => {
    this.setState({editing: false});
  }

  onInputChange = (value) => {
    const {formKey, personaStore, templateStore} = this.props;
    const {body, updateBody} = personaStore;
    const originalValue = body[formKey] ? body[formKey] : templateStore.selectedTemplate[formKey];
    if (originalValue !== value){
      const newPersona = Object.assign({}, body, {[formKey]: value});
      updateBody(newPersona);
    }
    this.viewMode();
  }

  render() {
    const {editing} = this.state;
    const {formKey, hideLabel, personaStore, templateStore} = this.props;
    const {body, isEditable} = personaStore;
    const value = body[formKey] ? body[formKey] : templateStore.selectedTemplate[formKey];
    const label = formKey.replace(/_/g, ' ').toLowerCase();
    const fieldClasses = classnames([
      'text',
      {
        'editable': isEditable,
      }
    ]);

    return (
      // Ghetto Workaround to get fields a custom class to pass values to.
      // TODO Fix this shit
      <div className={fieldClasses} onClick={this.editMode}>
        {!hideLabel && <div className="text-label">{label}: </div>}
        {editing && <TextEditor value={value} onBlur={this.onInputChange} {...this.props}/>}
        {!editing && <TextViewer value={value}{...this.props}/>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/persona/TextField.jsx